// extracted by mini-css-extract-plugin
export var checkbox = "_2l-0";
export var circle = "_2l-3";
export var horizontalContainer = "_2l-7";
export var sm = "_2l-5";
export var switch0 = "_2l-2";
export var switchDisabled = "_2l-8";
export var switchEnabled = "_2l-1";
export var textSwitchContainer = "_2l-9";
export var textSwitchOption = "_2l-a";
export var textSwitchOptionSelected = "_2l-b";
export var verticalContainer = "_2l-6";
export var xs = "_2l-4";